import React from 'react';

const MVPDPicker = ({ onMvpdSignInClick, withMvpds }) => {
  return (
    <div className="panelWrapper mvpd">
      <div className="mvpdWrapper">
        {withMvpds.map((mvpd, index) => {
          const { name, imageSrc, autoSize } = mvpd;
          return (
            <button key={index} type="button" className="mvpdButton" onClick={() => onMvpdSignInClick(mvpd)}>
              <img className={`logo ${autoSize ? 'auto' : ''}`} src={imageSrc} alt={name} />
            </button>
          );
        })}
      </div>
      <div className="secondaryText">
        {`Don't see your TV Provider? Visit `}
        <a key="helpLink" href="http://foxnation.com/help" className="blueLink" target="_blank">
          help.fox.com
        </a>{' '}
        for more info
      </div>
    </div>
  );
};

export default MVPDPicker;
